import { render } from "./laundry-booking-tile.vue?vue&type=template&id=7b60730c"
import script from "./laundry-booking-tile.vue?vue&type=script&lang=js"
export * from "./laundry-booking-tile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__